<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2021-2023 (original work) Open Assessment Technologies SA
    import ActionForm from '@/component/actionForm/ActionForm.svelte';
    import { actionsList } from '@/core/utils/consts';
    import { getCategories, getSubcategories } from '@/component/report/dropdownOptions';
    import RibbonContainer from '@/component/ui-elements/ribbonContainer/RibbonContainer.svelte';
    import NotificationManager from '@/component/ui-elements/notificationManager/NotificationManager.svelte';

    const categories = getCategories();
    const subcategories = getSubcategories();
    const type = actionsList.report;

    let RibbonContainerInstance;
</script>

<ActionForm {type} {categories} {subcategories} />
<RibbonContainer bind:this={RibbonContainerInstance} />
<NotificationManager />
